import React, { useEffect, useState } from 'react';
import './styles/BuildCoinsTransactionHistory.css';
import buildCoinsService from '../../service/BuildCoins.service';
import { BuildCoinsTransactionHistory as BuildCoinsTrxHistory } from '../../dto/BuildCoins.dto';
import { ProfileService } from '../../service/Profile.service';
import { ApiService } from '../../../../shared/service/Apiservice';
import axios from 'axios';

const BuildCoinsTransactionHistory: React.FC = () => {
    const [userBalance, setUserBalance] = useState<number>(0);
    const [history, setHistory] = useState<BuildCoinsTrxHistory | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const load = async () => {
            try {
                setLoading(true);
                
                const apiService = new ApiService(axios.create());
                const profileService = new ProfileService(apiService);
                
                const [profileRes, trxRes] = await Promise.all([
                    profileService.getUserProfile(),
                    buildCoinsService.getTransactionHistory(1, 10),
                ]);
                
                if (profileRes.success && profileRes.user) {
                    setUserBalance(profileRes.user.referralCredits || 0);
                }
                if (trxRes.success) setHistory(trxRes.data);
            } finally {
                setLoading(false);
            }
        };
        load();
    }, []);

    return (
        <div className="transaction-history-container">
            <div className="transaction-main-card">
                <div className="transaction-header">
                    <img src="/icon/current.png" alt="Coin Icon" className="coin-icon-header" />
                    <span className="balance-text">Build Coin Balance</span>
                    <div className="coin-amount-display">
                        <span className="rupee-symbol">₹</span>
                        <span className="balance-amount">{loading ? '—' : (Math.round(userBalance * 100) / 100)}</span>
                    </div>
                </div>

                <div className="reward-cards-wrapper">
                    <div className="reward-cards-container">
                        <div className="reward-card">
                            <div className="reward-card-content">
                                <img
                                    src="/icon/current.png"
                                    alt="Coin"
                                    className="reward-coin-icon"
                                />
                                <span className="reward-percentage">5% Build Coins</span>
                            </div>
                            <div className="reward-overlay-text">On every order above 2000/-</div>
                        </div>
                        <div className="reward-card">
                            <div className="reward-card-content">
                                <img
                                    src="/icon/current.png"
                                    alt="Coin"
                                    className="reward-coin-icon"
                                />
                                <span className="reward-percentage">5% Build Coins</span>
                            </div>
                            <div className="reward-overlay-text">On every order above 2000/-</div>
                        </div>
                    </div>
                </div>
                <div className="history-section">
                    <div className="validity-info">
                        <div className="history-title-container">
                            <h2 className="history-title">Transaction History</h2>
                        </div>
                        <p className="validity-text">
                            Regular coins issued form Jan 2025 will have 6 months validity from the date of credit.
                        </p>
                    </div>
                    <div className="transactions-list">
                        {history?.transactions?.length ? (
                            history.transactions.map((t) => (
                                <div key={t.id} className="transaction-item">
                                    <div className="transaction-left">
                                        <div className="transaction-order-info">
                                            {t.description}
                                        </div>
                                        <div className="transaction-date">
                                            {new Date(t.createdAt).toLocaleDateString()}
                                        </div>
                                    </div>
                                    <div className="transaction-right">
                                        <span className="transaction-coins" style={{ color: (t.transactionType === 'earned' || t.transactionType === 'refunded') ? '#16a34a' : '#dc2626' }}>
                                            {(t.transactionType === 'earned' || t.transactionType === 'refunded') ? '+' : '-'}{Math.round(t.amount * 100) / 100}
                                        </span>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div style={{ padding: '16px', color: '#666' }}>
                                {loading ? 'Loading transactions…' : 'No transactions yet.'}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}; 

export default BuildCoinsTransactionHistory;